import utils from "Sources/utils/utils";
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/game/questionnaire.html";

require("Styles/components/views/questionnaire.scss");

const questions = [
    {
        id: "item_type_matrix",
        type: "matrix",
        multiple_choice: true,
        title: "questionnaire.question_group.item_type_matrix.title",
        description: "",
        questions: [
            {
                id: "bought_second_hand",
                title_key: "questionnaire.question_group.item_type_matrix.question.bought_second_hand"
            },
            {
                id: "sold_second_hand",
                title_key: "questionnaire.question_group.item_type_matrix.question.sold_second_hand"
            },
            { id: "repaired", title_key: "questionnaire.question_group.item_type_matrix.question.repaired" },
            { id: "rented", title_key: "questionnaire.question_group.item_type_matrix.question.rented" },
            { id: "thrown_away", title_key: "questionnaire.question_group.item_type_matrix.question.thrown_away" },
        ],
        answers: [
            {
                id: "smartphone",
                value: "smartphone",
                title_key: "questionnaire.question_group.item_type_matrix.answer.smartphone"
            },
            { id: "bike", value: "bike", title_key: "questionnaire.question_group.item_type_matrix.answer.bike" },
            {
                id: "clothes",
                value: "clothes",
                title_key: "questionnaire.question_group.item_type_matrix.answer.clothes"
            },
            {
                id: "toys_games",
                value: "toys_games",
                title_key: "questionnaire.question_group.item_type_matrix.answer.toys_games"
            },
            {
                id: "luxury_items",
                value: "luxury_items",
                title_key: "questionnaire.question_group.item_type_matrix.answer.luxury_items"
            },
            { id: "none", value: "none", title_key: "questionnaire.question_group.item_type_matrix.answer.none" },
        ]
    },
    {
        id: "statement_agreement",
        type: "matrix",
        multiple_choice: false,
        title: "questionnaire.question_group.statement_agreement.title",
        description: "",
        questions: [
            {
                id: "phone_repair_over_new",
                title_key: "questionnaire.question_group.statement_agreement.question.phone_repair_over_new"
            },
            {
                id: "clothes_repair_over_new",
                title_key: "questionnaire.question_group.statement_agreement.question.clothes_repair_over_new"
            },
            {
                id: "phone_check_before_new",
                title_key: "questionnaire.question_group.statement_agreement.question.phone_check_before_new"
            },
            {
                id: "clothes_check_before_new",
                title_key: "questionnaire.question_group.statement_agreement.question.clothes_check_before_new"
            },
            {
                id: "phone_pay_more_environment",
                title_key: "questionnaire.question_group.statement_agreement.question.phone_pay_more_environment"
            },
            {
                id: "clothes_pay_more_environment",
                title_key: "questionnaire.question_group.statement_agreement.question.clothes_pay_more_environment"
            },
            {
                id: "phone_latest_model",
                title_key: "questionnaire.question_group.statement_agreement.question.phone_latest_model"
            },
            {
                id: "clothes_latest_model",
                title_key: "questionnaire.question_group.statement_agreement.question.clothes_latest_model"
            },
            {
                id: "phone_owning_over_subscription",
                title_key: "questionnaire.question_group.statement_agreement.question.phone_owning_over_subscription"
            },
            {
                id: "clothes_owning_over_subscription",
                title_key: "questionnaire.question_group.statement_agreement.question.clothes_owning_over_subscription"
            },
        ],
        answers: [
            { id: "strong_disagree", value: "strong_disagree", title_key: "questionnaire.likert.strong_disagree" },
            { id: "disagree", value: "disagree", title_key: "questionnaire.likert.disagree" },
            { id: "neutral", value: "neutral", title_key: "questionnaire.likert.neutral" },
            { id: "agree", value: "agree", title_key: "questionnaire.likert.agree" },
            { id: "strong_agree", value: "strong_agree", title_key: "questionnaire.likert.strong_agree" },
            { id: "none", value: "none", title_key: "questionnaire.likert.none" },
        ]
    },
    {
        id: "risk_taker",
        type: "discrete",
        multiple_choice: false,
        title: "questionnaire.question_group.risk_taker.title",
        description: "questionnaire.question_group.risk_taker.description",
        questions: [
            { id: "risk_taker" }
        ],
        answer_range: [ 1, 10 ],
        leftOption: "questionnaire.question_group.risk_taker.leftOption",
        rightOption: "questionnaire.question_group.risk_taker.rightOption"
    },
    {
        id: "give_up_benefit",
        type: "discrete",
        multiple_choice: false,
        title: "questionnaire.question_group.give_up_benefit.title",
        description: "questionnaire.question_group.give_up_benefit.description",
        questions: [
            { id: "give_up_benefit" }
        ],
        answer_range: [ 1, 10 ],
        leftOption: "questionnaire.question_group.give_up_benefit.leftOption",
        rightOption: "questionnaire.question_group.give_up_benefit.rightOption"
    }
];

class QuestionnaireView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.path = "questionnaire";
        this.onSubmitQuestionnaire = options.onSubmitQuestionnaire;
    }

    render()
    {
        super.render();

        this.setUpEventListeners();
        this.onRender();
    }

    onRender()
    {
        super.onRender();

        this.generateQuestionsHTML(questions);
    }

    generateQuestionsHTML(questions)
    {
        questions.forEach(question =>
        {
            switch (question.type)
            {
                case "matrix":
                    this.generateMatrixQuestionHTML(question);
                    break;
                case "discrete":
                    this.generateDiscreteQuestionHTML(question);
                    break;
                default:
                    console.warn(`Unsupported type '${question.type}' for question '${question.id}'`);
            }
        });

        LanguageManager.applyLocale($("#questionnaire__container"));
    }

    generateMatrixQuestionHTML(questionGroup)
    {
        const $questionSection = $("<section class='matrix'>");
        $questionSection.append(`<div class="question-group-title" data-localize="${questionGroup.title}"></div>`);
        $questionSection.append(`<div class="question-group-description" data-localize="${questionGroup.description}"></div>`);

        const $questionGroupTable = $(`<div class="answer-table" style="grid-template-columns: 3fr repeat(${questionGroup.answers.length}, 130px)">`);
        $questionSection.append($questionGroupTable);

        $questionGroupTable.append("<div>");
        questionGroup.answers.forEach(answer =>
        {
            $questionGroupTable.append(`<div class="answer-option-title" data-localize="${answer.title_key}"></div>`);
        });

        questionGroup.questions.forEach((question, index) =>
        {
            const backgroundColorClass = index % 2 === 0 ? "background-color-even" : "background-color-odd";
            $questionGroupTable.append(`<div class="question-title ${backgroundColorClass}" data-localize="${question.title_key}"></div>`);

            questionGroup.answers.forEach(answer =>
            {
                const concatID = `${question.id}_${answer.id}`;
                $questionGroupTable.append(`<div class="answer-option  ${backgroundColorClass}"><input id="${concatID}" name="${question.id}" value="${answer.id}" type="${questionGroup.multiple_choice ? "checkbox" : "radio"}"><label class="clickable-label" for="${concatID}"></label></div>`);
            });
        });

        $("#questionnaire__container").append($questionSection);
    }

    generateDiscreteQuestionHTML(questionGroup)
    {
        const $questionSection = $("<section class='discrete'>");

        $questionSection.append(`<div class="question-group-title" data-localize="${questionGroup.title}"></div>`);
        $questionSection.append(`<div data-localize="${questionGroup.description}"></div>`);

        questionGroup.questions.forEach(question =>
        {
            const $answerGroup = $(`<div class="answer-table" style="grid-template-columns: repeat(${questionGroup.answer_range[1] - questionGroup.answer_range[0] + 1 + 2}, 1fr)">`);
            $questionSection.append($answerGroup);

            $answerGroup.append(`<div style="text-align: right; display: flex; flex-direction: column; justify-content: flex-end; font-weight: bold; line-height: 1.4rem;"><span data-localize="${questionGroup.leftOption}"></span></div>`);
            for (let i = questionGroup.answer_range[0]; i <= questionGroup.answer_range[1]; ++i)
            {
                const concatID = `${question.id}_${i}`;
                $answerGroup.append(`<div class="answer-option"><label class="font-weight-bold">${i}</label><input id="${concatID}" name="${question.id}" value="${i}" type="radio"><label class="clickable-label" for="${concatID}"></label></div>`);
            }
            $answerGroup.append(`<div style="text-align: left; display: flex; flex-direction: column; justify-content: flex-end; font-weight: bold; line-height: 1.4rem;"><span data-localize="${questionGroup.rightOption}"></span></div>`);
        });

        $("#questionnaire__container").append($questionSection);
    }

    buildQuestionnaireAnswers()
    {
        let answers = [];
        questions.forEach(questionGroup =>
        {
            questionGroup.questions.forEach(question =>
            {
                answers.push({
                    id: question.id,
                    answers: $(`input[name="${question.id}"]:checked`).map(function()
                    {
                        return this.value;
                    }).get()
                });
            });
        });

        return answers;
    }

    setUpEventListeners()
    {
        this.$element.find(".submit-questionnaire-btn").off("click").on("click", (e) =>
        {
            const result = this.buildQuestionnaireAnswers();
            this.onSubmitQuestionnaire.call(this, { result });
        });
    }
}

module.exports = QuestionnaireView;


// WEBPACK FOOTER //
// ./app/js/components/game/views/questionnaire.js